<template>
  <div style="padding-top: 10px">
    <div class="title">{{ $route.query.name }}</div>
    　　<iframe
      id="frame"
      style="width: 100%; height: 90vh"
      :src="$route.query.url"
    ></iframe>
  </div>
</template>

<script>
export default {
  created() {
    console.log(this.$route.query.url);
  },

  methods: {
    setHeight(obj) {
      return;
      var w = obj;
      if (document.getElementById) {
        if (w && !window.opera) {
          if (w.contentDocument && w.contentDocument.body.offsetHeight) {
            w.height = w.contentDocument.body.offsetHeight + 40;
          } else if (w.Document && win.Document.body.scrollHeight) {
            w.height = win.Document.body.scrollHeight + 40;
          }
        }
      }
    },
  },
};
</script>
<style scoped>
.title {
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  color: #fff;
   background: linear-gradient(45deg, rgb(99, 154, 249), rgb(123, 151, 232));
}
</style>
<style>
html,
body,
#app {
  height: 100%;
  width: 100%;
  min-width: 100px;
}
</style>


// WEBPACK FOOTER //
// src/views/live/live.vue